import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows_right",
  "use": "icon-arrows_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrows_right\"><path d=\"M512 64.5C264.9 64.5 64.5 264.9 64.5 512S264.9 959.5 512 959.5 959.5 759.1 959.5 512 759.1 64.5 512 64.5z m-11.6 615.4h-130L523.6 512 370.4 344.1h129.9L653.6 512 500.4 679.9z\" p-id=\"11232\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol